export default __webpack_public_path__ + "static/media/537061__imafoley__message-pop-sound.6c808b35.wav";